import { motion } from "framer-motion";
import { Reveal } from "@/components/landing/Reveal";

const STEPS = [
  {
    n: "01",
    time: "10–15 min",
    title: "Accoglienza e ascolto",
    text: "Si comincia parlando, senza strumenti. Ci racconti cosa ti preoccupa, eventuali paure ed esperienze passate. Concordiamo insieme un segnale, basta alzare la mano, per fermarci in qualsiasi momento.",
  },
  {
    n: "02",
    time: "5–10 min",
    title: "Anamnesi",
    text: "Qualche domanda sulla tua salute generale: farmaci, diabete, fumo, gravidanza, familiarità per la parodontite e abitudini di igiene. Sono informazioni preziose per capire le cause e scegliere la terapia più sicura.",
  },
  {
    n: "03",
    time: "15–20 min",
    title: "Visita e sondaggio parodontale iniziale",
    text: "Con una sonda millimetrata a punta arrotondata misuriamo delicatamente la profondità dello spazio tra dente e gengiva in 6 punti per ogni dente. Annotiamo anche sanguinamento, placca, recessioni e mobilità. Se sei molto sensibile, possiamo usare un gel anestetico.",
  },
  {
    n: "04",
    time: "10 min",
    title: "Valutazione delle tasche",
    text: "Tutte le misure compongono la tua cartella parodontale: una mappa precisa delle gengive. Se serve, la completiamo con radiografie. Così possiamo definire stadio e gravità della parodontite, dente per dente.",
  },
  {
    n: "05",
    time: "10 min",
    title: "Il tuo piano di cura, spiegato con calma",
    text: "Ti mostriamo cosa abbiamo trovato con parole semplici e ti proponiamo il percorso laser più adatto: numero di sedute, tempi e costi, per iscritto. Nessuna decisione va presa sul momento: decidi tu, quando ti senti pronto.",
  },
];

const Step = ({ s, i }) => (
  <Reveal delay={i * 0.06} className="relative pl-16 sm:pl-24 pb-14 last:pb-0" >
    <span className="absolute left-0 top-0 f-mono text-xs tracking-[0.2em] text-[#3E6B48] bg-[#E6ECE4] rounded-full w-11 h-11 sm:w-14 sm:h-14 grid place-items-center" data-testid={`visit-step-${s.n}`}>{s.n}</span>
    <p className="eyebrow text-[#526356]">{s.time}</p>
    <h3 className="f-serif text-3xl sm:text-4xl text-[#1B3B28] mt-2 leading-tight">{s.title}</h3>
    <p className="text-[#526356] mt-3 leading-relaxed max-w-2xl">{s.text}</p>
  </Reveal>
);

export const VisitSteps = () => (
  <div className="relative" data-testid="visit-steps">
    <motion.span
      className="absolute left-[21px] sm:left-[27px] top-2 bottom-2 w-px bg-[#3E6B48]/30 origin-top"
      initial={{ scaleY: 0 }} whileInView={{ scaleY: 1 }} viewport={{ once: true }} transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
    />
    {STEPS.map((s, i) => <Step key={s.n} s={s} i={i} />)}
  </div>
);
